export const getProjectsPath = (projectsFolderId: string) => `/projects/${projectsFolderId}`;
export const getProjectPath = (projectId: string) => `/project/${projectId}`;
